module.exports = __webpack_public_path__ + "media/images/default-bottle-d42f037ca81e5d7550cec02e4d444aff.png";